import { PDP_MEDIA_LOADED } from 'features/product-info/components/pdp-media-gallery/actions';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { isProductSet, selectProductPriceCategory } from 'features/product-info';
import { NOT_SET } from '../utils';
import { selectProductBelong, selectProductId, selectProductName, selectProductPrice } from './selectors';

/**
 * Cобытие должно срабатывать при полной загрузке и открытии медиафайла после клика по превью.
 * В частности речь идет о функционале “Ракурс 360”
 * (пример, https://lemanapro.ru/product/podves-kvadrat-1xe27h60-vt-17984501/),
 * где после клика на превью изображение некоторое время загружается.
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaMediaLoad = createAction('GA:mediaLoad')<{
  elementType: 'mediaContent';
  elementBlock: 'productDetail' | 'komplektyDetail'; // блок, в котором расположен элемент
  elementName: string; // тип контента из Media Repository
  mediaLink: string; // ссылка на видео/картинку
  elementLoadTime: string; // время от клика по медиафайлу, за которое файл полностью загрузился и открылся (в миллисекундах)

  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productTag: string; // bestPrice для “Лучшей цены” и onlineOnly для “Только онлайн заказ”, а также остальные бейджи. При наличии нескольких передавать через разделитель “,”
  productBelong: 'LeroyMerlin' | 'LeroyMerlinMarketplace' | 'Longtail'; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  komplektyId: string | null; // идентификатор комплекта (Передавать, если товар-комплект). Для обычных товаров не передавать этот параметр
}>();

function* putGaMediaLoad(mediaType?: string, contentLink?: string, loadTime?: number) {
  const isSet: boolean = yield select(isProductSet);

  const elementName = mediaType ?? NOT_SET;
  const mediaLink = contentLink ?? NOT_SET;
  const elementLoadTime = loadTime && Number.isFinite(loadTime) ? loadTime.toFixed(0) : NOT_SET;
  const komplektyId: string | null = isSet ? yield call(selectProductId) : null;
  const elementBlock = isSet ? 'komplektyDetail' : 'productDetail';

  yield put(
    gaMediaLoad({
      elementType: 'mediaContent',
      elementBlock,
      productName: yield call(selectProductName),
      productId: yield call(selectProductId),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productTag: yield call(selectProductPriceCategory),
      elementName,
      mediaLink,
      elementLoadTime,
      komplektyId,
    }),
  );
}

export function* runMediaLoadDetector() {
  yield takeEvery(PDP_MEDIA_LOADED, function* handle({ payload }) {
    const { mediaType, contentLink, loadTime } = payload;
    yield putGaMediaLoad(mediaType, contentLink, loadTime);
  });
}
